export class ConfigsPublicModel {
  resource_domain: string = "";
  realtime_domain: string = "";
  constructor(data?: Partial<ConfigsPublicModel>) {
    Object.assign(this, data);
  }
}
